import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as jwt_decode from 'jwt-decode';
import { withRouter } from 'react-router-dom';
import {
  Layout,
  Row,
  Col,
  Card,
  Collapse,
  Icon,
  Spin,
  Tabs,
  message,
  Button,
  Table,
  Divider,
  Popconfirm,
  Tooltip,
  Alert,
} from 'antd';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getDataUserCompany,
  getModalTrue,
  getIdFilial,
} from '../../redux/actions';
import moment from 'moment';

import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Breadcrumb from '../../components/Breadcrumb';
import ModalCreateFilial from '../../components/ModalCreateFilial';
import ModalInvitation from '../../components/ModalInvitation';
import ModalUpdateCompany from '../../components/ModalUpdateCompany';
import ModalUpdateFilial from '../../components/ModalUpdateFilial';
import QuestionsClient from '../../components/QuestionsClient';
import Alerts from '../../components/Alerts';
import ModalBeneficio from '../../components/ModalBeneficio';
import ModalUtilizarCupom from '../../components/ModalUtilizarCupom';
//import ModalCreateCompany from '../../components/ModalCreateCompany';

import Service from './Service';
import './styles.css';
import RedeSocial from '../../components/RedeSocial';
import ModalLogomarca from '../../components/ModalLogomarca';
import ModalTemplateEmail from '../../components/ModalTemplateEmail';
import { obterTemplate } from '../../components/ModalTemplateEmail/services';
import ModalConvidarUsuario from '../../components/ModalConvidarUsuario';
import ModalAdicionarUnidade from '../../components/ModalAdicionarUnidade';

const { Content } = Layout;
const Panel = Collapse.Panel;
const { TabPane } = Tabs;

class SettingsBlue extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      visible: false,
      visibleFilial: false,
      visibleTeste: false,
      visibleUpdateFilial: false,
      data: {},
      dataQuestions: {},
      dataQuestionsEmpresa: {},
      companyListUser: [],
      showLink: false,
      showRankCupom: true,
      modalBeneficio: {
        visible: false,
        data: {},
      },
      modalUtilizarCupom: {
        visible: false,
        data: {},
      },
      modalLogomarca: {
        visible: false,
        empresaId: 0,
        filialId: 0,
        nomeEmpresa: '',
        nomeFilial: '',
      },
      modalTemplateEmail: {
        visible: false,
        empresaId: 0,
        nomeEmpresa: '',
      },
      modalConvidarUsuario: {
        visible: false,
        empresa: null,
      },
      modalAdicionarUnidade: {
        visible: false,
        registro: null,
      },
      updateCompanyId: 0,
      updateFilialId: 0,
      // AcessoTotal por empresa (Empresa/listar-grupos-usuario) - usado so pra
      // ESCONDER proativamente acoes que o usuario restrito por unidade
      // (PessoaFilal) nao pode fazer (2026-08-09). Nao e fonte de autorizacao -
      // isso continua 100% no backend; aqui e so UX, pra nao deixar o usuario
      // clicar em algo que vai tomar 403.
      gruposAcesso: [],
    };

    this.service = new Service();
  }

  abrirModalBeneficio(beneficio) {
    this.setState({
      visible: false,
      visibleUpdateFilial: false,
      visibleFilial: false,
      visibleTeste: false,
      modalBeneficio: {
        visible: true,
        data: beneficio,
      },
    });
  }

  fecharModalBeneficio() {
    const self = this;

    return () =>
      self.setState({
        modalBeneficio: {
          visible: false,
          data: {},
        },
      });
  }

  salvarBeneficio() {
    const self = this;

    return formData => {
      this.service
        .saveBeneficio(formData)
        .then(function(result) {
          if (result && result.object && result.object.sucesso) {
            message.success('Dados salvos com sucesso!', () => {
              let currentState = self.state;
              let resultBeneficio = result.object.beneficio || {};

              if (currentState && Array.isArray(currentState.data)) {
                currentState.data.forEach(e => {
                  const idEmpresa = (e || {}).id;
                  if (idEmpresa == resultBeneficio.idEmpresa) {
                    e.beneficio = resultBeneficio;
                  }
                });

                currentState.modalBeneficio = {
                  visible: false,
                  data: {},
                };
                self.setState(currentState);
              }
            });
            return;
          }

          if (result && result.mensage) {
            message.error(result.mensage);
          } else {
            message.error('Erro inesperado. Tente novamente!');
          }
        })
        .catch(function() {
          console.log('err:', arguments);
          message.error('Houve um erro inesperado. Tente novamente!');
        });
    };
  }

  abrirModalUtilizarCupom(filial) {
    this.setState({
      modalUtilizarCupom: {
        visible: true,
        data: { filial },
        cupomSelecionado: null,
      },
    });
  }

  fecharModalUtilizarCupom() {
    const self = this;

    return () =>
      self.setState({
        modalUtilizarCupom: {
          visible: false,
          data: {},
        },
      });
  }

  pesquisarCupom() {
    const self = this;

    return (idFilial, numero, done) => {
      this.service
        .pesquisarCupom(idFilial, numero)
        .then(function(result) {
          if (result && result.object) {
            self.setState({
              modalUtilizarCupom: {
                visible: self.state.modalUtilizarCupom.visible,
                data: self.state.modalUtilizarCupom.data,
                cupomSelecionado: result.object,
              },
            });
            done();
            return;
          }

          if (result && result.mensage) {
            message.error(result.mensage);
          } else {
            message.error('Erro inesperado. Tente novamente!');
          }
          done();
        })
        .catch(function() {
          console.log('err:', arguments);
          message.error('Houve um erro inesperado. Tente novamente!');
          done();
        });
    };
  }

  utilizarCupom() {
    const self = this;

    return (idFilial, numero, done) => {
      this.service
        .utilizarCupom(idFilial, numero)
        .then(function(result) {
          if (result && result.object) {
            message.success(
              `O cupom "${numero}" foi utilizado com sucesso!`,
              () => {
                self.setState({
                  modalUtilizarCupom: {
                    visible: false,
                    data: {},
                  },
                });
                done();
              }
            );
            return;
          }

          if (result && result.mensage) {
            message.error(result.mensage);
          } else {
            message.error('Erro inesperado. Tente novamente!');
          }
          done();
        })
        .catch(function() {
          console.log('err:', arguments);
          message.error('Houve um erro inesperado. Tente novamente!');
          done();
        });
    };
  }

  componentDidMount() {
    if (!this.service.isLogged()) {
      this.props.history.push('/login');
    } else {
      const token = this.props.userData.object.token;
      const decodeToken = jwt_decode(token);
      this.setState({
        role: decodeToken.role,
        dataUser: decodeToken,
        visible: false,
      });

      this.listCompany();
      this.listUserCompany();
      this.listCompanyFilial();
      this.listSegment();
      this.getListQuestions();
      this.getAlertStatus();
      this.getCupomPersonalizado();
      this.loadGruposAcesso();
    }
  }

  // Ver comentario de gruposAcesso no estado inicial.
  loadGruposAcesso = async () => {
    const result = await this.service.getGruposUsuario();
    this.setState({ gruposAcesso: (result && result.object) || [] });
  };

  // true por padrao (nao restrito) se a empresa ainda nao apareceu em
  // gruposAcesso (ex.: essa chamada nao terminou ainda, ou API antiga sem o
  // campo acessoTotal) - nunca esconder por engano enquanto carrega.
  temAcessoTotal = idEmpresa => {
    const grupo = this.state.gruposAcesso.find(g => g.grupoId === idEmpresa);
    return !grupo || grupo.acessoTotal !== false;
  };

  // Diferente de temAcessoTotal (que reflete ALCANCE DE DADO - usado so pro
  // dropdown "Ver todas as unidades", fora deste arquivo): esta decide se
  // MOSTRA os botoes de acao de nivel empresa (convidar, promover, adicionar
  // unidade, editar empresa/filial, logo, cupom). Antes essas acoes usavam
  // temAcessoTotal tambem - divergia da autorizacao real assim que uma pessoa
  // restrita passasse a cobrir 100% das unidades (2026-08-12): via os botoes,
  // backend recusava. A autorizacao de verdade continua 100% no backend; isso
  // e so pra nao mostrar um botao que vai dar erro.
  podeAdministrarEmpresa = idEmpresa => {
    const grupo = this.state.gruposAcesso.find(g => g.grupoId === idEmpresa);
    return !grupo || grupo.podeAdministrarEmpresa !== false;
  };

  componentWillReceiveProps(props) {
    const idUnidade = props.dataFilial.length > 0 ? props.dataFilial[0].id : 0;
    const idGrupo =
      props.companySelected.length > 0 ? props.companySelected[0].id : 0;
    this.setState({
      idUnidade,
      idGrupo,
    });
    if (
      (idUnidade > 0 && idUnidade !== this.state.idUnidade) ||
      (idGrupo > 0 && idGrupo !== this.state.idGrupo)
    ) {
      const token = this.props.userData.object.token;
      const decodeToken = jwt_decode(token);
      this.setState({
        role: decodeToken.role,
        dataUser: decodeToken,
        visible: false,
      });

      this.listCompany();
      this.listUserCompany();
      this.listCompanyFilial();
      this.listSegment();
      this.getListQuestions(idGrupo);
      this.getAlertStatus();
      this.getCupomPersonalizado(idGrupo);
    }
  }

  componentWillUnmount() {
    this.setState({
      visible: false,
      visibleFilial: false,
      visibleTeste: false,
      visibleUpdateFilial: false,
      dataQuestionsEmpresa: [],
    });
  }

  async listCompanyFilial() {
    this.setState({ loading: true });
    const result = await this.service.listCompanyFilial();

    if (result === undefined) {
      await this.service.doLogout();
      this.props.history.push('/login');
    } else {
      this.props.dataUserCompany.map(company => {
        return result.object.filter(filial => {
          return filial.id === company.id;
        });
      });

      this.setState({ loading: false, dataFilial: result.object });
    }
  }

  listSegment = async () => {
    const result = await this.service.listSegment();

    if (result === undefined) {
      await this.service.doLogout();
      this.props.history.push('/login');
    } else {
      this.setState({ segment: result });
    }
  };

  async listCompany() {
    this.setState({ loading: true });
    const result = await this.service.listCompany();

    this.props.getDataUserCompany(result.object);

    if (result === undefined) {
      await this.service.doLogout();
      this.props.history.push('/login');
    } else {
      this.setState({ loading: false, data: result.object });
      this.props.getDataUserCompany(result.object);
    }
    this.setState({ loading: false });
  }
  callback(key) {
    console.log(key);
  }

  async listUserCompany() {
    const result = await this.service.listUserCompany();
    this.setState({ companyListUser: result.object });
  }

  onChange = () => {
    console.log('onChange');
  };

  onCreateFilial = async payload => {
    const response = await this.service.createCompanyFilial(payload);
    if (response && response.code === 200) {
      this.setState({
        visible: false,
        visibleFilial: false,
        visibleTeste: false,
        visibleUpdateFilial: false,
      });
      this.listCompanyFilial();
      this.listCompany();
      this.props.getModalTrue({ visible: false });
      message.success('Unidade cadastrada com sucesso!');
      return true;
    } else {
      message.error('Não foi possível cadastrar a unidade!');
      return false;
    }
  };

  async updateFilial(payload) {
    const response = await this.service.updateFilial(payload);
    if (response && response.code === 200) {
      this.setState({
        visible: false,
        visibleFilial: false,
        visibleTeste: false,
        visibleUpdateFilial: false,
      });
      this.listCompanyFilial();
      this.listCompany();
      this.props.getModalTrue({ visible: false });
      return true;
    } else {
      message.error('Não foi possível atualizar a filial!');
      return false;
    }
  }

  generateQRCodeUrl(url) {
    const baseUrl = 'https://api.qrserver.com/v1/create-qr-code/';

    const chartSize = '180x180';

    const encodedUrl = url;

    const qrCodeUrl = `${baseUrl}?size=${chartSize}&data=${encodedUrl}`;

    return qrCodeUrl;
  }

  createInvitation = async data => {
    const response = await this.service.createInvitation(data);

    if (response && response.object === true) {
      this.setState({
        visible: false,
        visibleFilial: false,
        visibleTeste: false,
        visibleUpdateFilial: false,
        modalConvidarUsuario: { visible: false, empresa: null },
      });
      // code 203 (achado 2026-08-12): convite criado, mas o envio do e-mail
      // falhou (Mailgun) - antes esse retorno era descartado em silencio, sem
      // avisar quem convidou. O convite continua valendo mesmo assim (o
      // convidado ve pendente ao logar), so o aviso muda de sucesso pra alerta.
      if (response.code === 203) {
        message.warning(response.mensage);
      } else {
        this.success();
      }
      this.props.getModalTrue({ visible: false });
      // Sem isso, a tabela de Usuarios ficava desatualizada apos convidar -
      // achado 2026-08-12, ja que o convite recem-criado (pendente) agora
      // aparece la se a listagem passar a exibir pendentes tambem.
      this.listUserCompany();
      return true;
    } else {
      // Backend agora devolve mensagens especificas (convite duplicado, ja tem
      // acesso, sem permissao) - mostrar em vez do erro generico sempre que
      // vier preenchida. code 607 (achado 2026-08-12): "ja tem acesso" e generico
      // no backend (nao sabe se o convite que estava sendo tentado era total ou
      // restrito) - aqui a gente sabe (data.idsFiliais), entao troca pra uma
      // mensagem mais especifica em vez de usar o texto padrao do backend.
      if (response && response.code === 607) {
        const eraRestrito = data.idsFiliais && data.idsFiliais.length > 0;
        this.error(
          eraRestrito
            ? 'Esse usuário já tem acesso a essa unidade.'
            : 'Esse usuário já tem acesso a esse grupo.'
        );
      } else {
        this.error(response && response.mensage);
      }
      return false;
    }
  };

  cancelInvitation = async (idEmpresa, emailUser) => {
    const response = await this.service.cancelInvitation({
      idEmpresa,
      emailUser,
    });
    if (response && response.object === true) {
      message.success('Convite cancelado com sucesso!');
      this.listUserCompany();
    } else {
      message.error(
        (response && response.mensage) || 'Não foi possível cancelar o convite.'
      );
    }
  };

  getListQuestions = async idGrupo => {
    const result = await this.service.getListQuestions();
    if (this.props.companySelected && this.props.companySelected.length > 0) {
      let idEmpresa = idGrupo > 0 ? idGrupo : this.props.companySelected[0].id;
      const resultFilial = await this.service.getListQuestionsEmpresa(
        idEmpresa
      );
      this.setState({
        dataQuestions: result,
        dataQuestionsEmpresa: resultFilial,
      });
    } else {
      this.setState({ dataQuestions: result, dataQuestionsEmpresa: [] });
    }
  };

  getCupomPersonalizado = async idGrupo => {
    if (this.props.companySelected && this.props.companySelected.length > 0) {
      let idEmpresa = idGrupo > 0 ? idGrupo : this.props.companySelected[0].id;
      const result = await obterTemplate(idEmpresa);
      if (result.id > 0 && result.tipoRegra === 1 && result.status) {
        this.setState({
          showRankCupom: false,
        });
      } else {
        this.setState({
          showRankCupom: true,
        });
      }
    }
  };

  error = mensagem => {
    message.error(mensagem || 'Convite não enviado, entre em contato com a blue');
  };

  success = () => {
    message.success('Convite enviado com sucesso!');
  };

  // save state modal true in redux
  openModal(item) {
    this.setState({
      idPlan: item.id,
      plan: item,
      visible: false,
      visibleTeste: false,
      visibleUpdateFilial: false,
    });

    const payloadModal = {
      visible: true,
      data: item,
    };
    this.props.getModalTrue(payloadModal);
  }

  saveQuestions = async data => {
    this.setState({ loading: true });

    const arrData = [data];

    const teste = arrData[0].idPergunta.map((item, index) => {
      return [{ idPergunta: item }];
    });
    teste.unshift({ idEmpresa: data.idEmpresa });

    const payload = {
      idEmpresa: data.idEmpresa,
      idsPerguntas: data.idPergunta,
    };

    const result = await this.service.createListQuestions(payload);

    if (result.object !== false) {
      this.successQuestions();
      this.setState({
        loading: false,
      });
    } else {
      this.errorQuestions();
      this.setState({
        loading: false,
      });
    }
  };

  updateCompany = async data => {
    this.setState({ loading: true, updateCompanyId: 0 });
    if (data.idEmpresa) {
      await this.service.updateFilial(data);
      this.setState({ visible: false, loading: false });
      this.listCompanyFilial();
    } else {
      await this.service.updateCompany(data);
      this.setState({ visible: false, loading: false, updateCompanyId: 0 });
      this.listCompany();
      this.listCompanyFilial();
    }

    this.setState({ visible: false, loading: false, updateCompanyId: 0 });
  };

  getAlertStatus = async () => {
    const result = await this.service.getAlertStatus();
    this.setState({ alertStatus: result.object });
  };

  setAlertStatus = async status => {
    await this.service.setAlertStatus(status);
  };

  successQuestions = () => {
    message.success('Formulário criado com sucesso!');
  };

  errorQuestions = () => {
    message.error('Error ao criar formulário');
  };

  deleteUser = async (dataIndex, record) => {
    if (record.idVinculoEmpresa !== null) {
      const payloadEmpresa = {
        idVinculoEmpresa: record.idVinculoEmpresa,
        idVinculoFilial: 0,
      };
      await this.service.deleteUser(payloadEmpresa);
    } else {
      const payloadFilial = {
        idVinculoEmpresa: 0,
        idVinculoFilial: record.idVinculoFilial,
      };
      await this.service.deleteUser(payloadFilial);
    }
    this.listUserCompany();
  };

  promoverAcessoTotal = async record => {
    const result = await this.service.promoverAcessoTotal({
      idVinculoEmpresa: 0,
      idVinculoFilial: record.idVinculoFilial,
    });
    // ExcluirVinculoUsuario/PromoverAcessoTotal sempre devolvem HTTP 200 -
    // sucesso/falha vem no corpo (result.object), nao no status da resposta.
    if (!result || result.object !== true) {
      message.error(
        (result && result.mensage) ||
          'Não foi possível promover esse usuário a acesso total.'
      );
    }
    this.listUserCompany();
  };

  callback = key => {
    if (key.length === 2) {
      let idFilial = parseInt(key[1]);
      this.props.getIdFilial(idFilial);
    }
  };

  abrirModalLogomarca = (empresaId, filialId, nomeEmpresa, nomeFilial) => {
    this.setState({
      visible: false,
      visibleUpdateFilial: false,
      visibleFilial: false,
      visibleTeste: false,
      modalLogomarca: {
        visible: true,
        empresaId: empresaId,
        filialId: filialId,
        nomeEmpresa: nomeEmpresa,
        nomeFilial: nomeFilial,
      },
    });
  };

  abrirModalTemplate = (empresaId, nomeEmpresa) => {
    this.setState({
      visible: false,
      visibleUpdateFilial: false,
      visibleFilial: false,
      visibleTeste: false,
      modalTemplateEmail: {
        visible: true,
        empresaId: empresaId,
        nomeEmpresa: nomeEmpresa,
      },
    });
  };

  abrirModalConvidarUsuario = (idEmpresa, nomeEmpresa) => {
    this.setState({
      visible: false,
      visibleUpdateFilial: false,
      visibleFilial: false,
      visibleTeste: false,
      modalConvidarUsuario: {
        visible: true,
        empresa: { id: idEmpresa, nome: nomeEmpresa },
      },
    });
  };

  abrirModalAdicionarUnidade = registro => {
    this.setState({
      visible: false,
      visibleUpdateFilial: false,
      visibleFilial: false,
      visibleTeste: false,
      modalAdicionarUnidade: {
        visible: true,
        registro,
      },
    });
  };

  adicionarUnidades = async data => {
    const response = await this.service.adicionarUnidades(data);

    if (response && response.object === true) {
      this.setState({
        modalAdicionarUnidade: { visible: false, registro: null },
      });
      message.success('Unidade adicionada com sucesso!');
      this.props.getModalTrue({ visible: false });
      this.listUserCompany();
      return true;
    } else {
      this.error(response && response.mensage);
      return false;
    }
  };

  render() {
    const { dataFilial, companyListUser } = this.state;

    const homeClient = {
      home: 'Início',
      user: 'Índice Blue',
      company: 'NPS',
      companyClient: 'Empresa',
      contracts: 'Evoluções',
      plans: 'Avaliações',
      indicadores: 'Visão Geral',
      configuration: 'Opções',
      logout: 'Sair',
      iconClient: {
        home: 'home',
        user: 'area-chart',
        company: 'pie-chart',
        companyClient: 'bank',
        contracts: 'line-chart',
        plans: 'message',
        indicadores: 'dashboard',
        configuration: 'setting',
        logout: 'logout',
      },
    };

    const routesClient = {
      home: 'client',
      user: 'indexBlue',
      company: 'nps',
      companyClient: 'companyClient',
      contracts: 'evolution',
      plans: 'comments',
      indicadores: 'indicadores',
      configuration: 'settings',
    };

    // Aba "Usuário" reformulada (2026-08-10, pedido do usuario - a listagem
    // original misturava, numa unica tabela, vinculos de nivel empresa
    // (acesso total) e de nivel filial (acesso restrito) sem separar os
    // dois, confundindo quem via a tela. companyListUser continua vindo do
    // mesmo endpoint (Empresa/getUsuariosEmpresaFilial) - so filtramos aqui
    // pela presenca de idVinculoEmpresa vs idVinculoFilial, exatamente como
    // deleteUser ja fazia pra decidir qual exclusao chamar.
    const usuariosAcessoTotal = (companyListUser || []).filter(
      u => u.idVinculoEmpresa
    );
    const usuariosAcessoRestrito = (companyListUser || []).filter(
      u => u.idVinculoFilial
    );
    // Convite pendente (2026-08-12): nem acesso total nem restrito ainda -
    // idVinculoEmpresa/idVinculoFilial ficam vazios de proposito nesses itens.
    const usuariosPendentes = (companyListUser || []).filter(u => u.pendente);

    // A lista junta TODAS as empresas do usuario logado - sem agrupar,
    // virava uma bagunca so (usuarios de empresas diferentes intercalados
    // na mesma tabela). Agrupa por idEmpresa (nao por nome - duas empresas
    // podem ter o mesmo nome), exibindo o nome da empresa como subtitulo
    // acima da lista de usuarios daquele grupo.
    const agruparPorEmpresa = lista => {
      const grupos = [];
      (lista || []).forEach(usuario => {
        let grupo = grupos.find(g => g.idEmpresa === usuario.idEmpresa);
        if (!grupo) {
          grupo = {
            idEmpresa: usuario.idEmpresa,
            nomeEmpresa: usuario.nomeEmpresa,
            usuarios: [],
          };
          grupos.push(grupo);
        }
        grupo.usuarios.push(usuario);
      });
      return grupos;
    };

    const gruposAcessoTotal = agruparPorEmpresa(usuariosAcessoTotal);
    const gruposAcessoRestrito = agruparPorEmpresa(usuariosAcessoRestrito);
    const gruposPendentes = agruparPorEmpresa(usuariosPendentes);

    // O botao "Convidar usuario" fica so na PRIMEIRA secao em que a empresa
    // aparece (Total -> Restrito -> Pendentes), pra nao repetir o mesmo botao
    // 2-3 vezes quando a empresa tem gente nas tres listas.
    const idsComBotaoNoTotal = new Set(gruposAcessoTotal.map(g => g.idEmpresa));
    const idsComBotaoNoRestrito = new Set(
      gruposAcessoRestrito
        .filter(g => !idsComBotaoNoTotal.has(g.idEmpresa))
        .map(g => g.idEmpresa)
    );
    const botaoConvidar = (idEmpresa, nomeEmpresa) =>
      this.podeAdministrarEmpresa(idEmpresa) && (
        <Button
          size="small"
          icon="usergroup-add"
          style={{ marginLeft: 12 }}
          onClick={() =>
            this.abrirModalConvidarUsuario(idEmpresa, nomeEmpresa)
          }
        >
          Convidar usuário
        </Button>
      );

    const colunaAcoes = {
      title: 'Ações',
      dataIndex: 'id',
      key: 'acoes',
      className: 'col-action',
      align: 'right',
      render: (dataIndex, record) => (
        <Popconfirm
          placement="topRight"
          title={`Deseja excluir o usuário: ${record.email}?`}
          onConfirm={() => this.deleteUser(dataIndex, record)}
          okText="Sim"
          cancelText="Não"
        >
          <Icon className="table-actions" type="delete" title="Excluir acesso" />
        </Popconfirm>
      ),
    };

    const columnsAcessoTotal = [
      { title: 'Nome', dataIndex: 'nome', key: 'nome', width: 220 },
      { title: 'Email', dataIndex: 'email', key: 'email', width: 320 },
      { ...colunaAcoes, width: 90 },
    ];

    // Coluna de acoes da lista de acesso restrito e uma FUNCAO (nao um array
    // fixo, como colunaAcoes) porque os botoes de admin so aparecem pra quem
    // PODE ADMINISTRAR aquela empresa (this.podeAdministrarEmpresa e por
    // empresa, nao global) - precisa saber o idEmpresa do grupo sendo
    // renderizado. A autorizacao de verdade continua 100% no backend
    // (PromoverAcessoTotal/AdicionarUnidadesUsuario bloqueiam quem nao pode);
    // isso e so pra nao mostrar um botao que vai dar erro.
    const columnsAcessoRestrito = idEmpresa => [
      { title: 'Nome', dataIndex: 'nome', key: 'nome', width: 220 },
      { title: 'Email', dataIndex: 'email', key: 'email', width: 320 },
      { title: 'Unidade', dataIndex: 'nomeFilial', key: 'nomeFilial', width: 170 },
      {
        title: 'Ações',
        dataIndex: 'id',
        key: 'acoes',
        className: 'col-action',
        align: 'right',
        width: 160,
        render: (dataIndex, record) => (
          <span>
            {this.podeAdministrarEmpresa(idEmpresa) && (
              <Icon
                className="table-actions"
                type="plus-circle"
                title="Adicionar unidade"
                style={{ marginRight: 12 }}
                onClick={() => this.abrirModalAdicionarUnidade(record)}
              />
            )}
            {this.podeAdministrarEmpresa(idEmpresa) && (
              <Popconfirm
                placement="topRight"
                title={`Alterar ${record.nome} para acesso total ao grupo?`}
                onConfirm={() => this.promoverAcessoTotal(record)}
                okText="Sim"
                cancelText="Não"
              >
                <Icon
                  className="table-actions"
                  type="unlock"
                  title="Alterar para acesso total"
                  style={{ marginRight: 12 }}
                />
              </Popconfirm>
            )}
            {/* Backend (2026-08-12) so deixa excluir vinculo de OUTRA pessoa
                pra quem pode administrar a empresa - restrito so pode excluir
                o proprio. Aqui e so pra nao mostrar a lixeira em linha alheia
                pra quem vai tomar erro ao clicar. */}
            {(this.podeAdministrarEmpresa(idEmpresa) ||
              (this.state.dataUser &&
                record.email === this.state.dataUser.email)) && (
              <Popconfirm
                placement="topRight"
                title={`Deseja excluir o usuário: ${record.email}?`}
                onConfirm={() => this.deleteUser(dataIndex, record)}
                okText="Sim"
                cancelText="Não"
              >
                <Icon className="table-actions" type="delete" title="Excluir acesso" />
              </Popconfirm>
            )}
          </span>
        ),
      },
    ];

    const columnsPendentes = [
      { title: 'Email', dataIndex: 'email', key: 'email', width: 320 },
      {
        title: 'Unidade',
        dataIndex: 'nomeFilial',
        key: 'nomeFilial',
        width: 250,
        render: nomeFilial => nomeFilial || 'Acesso total',
      },
      {
        title: 'Ações',
        dataIndex: 'idEmpresa',
        key: 'acoes',
        className: 'col-action',
        align: 'right',
        width: 90,
        render: (idEmpresa, record) => (
          <Popconfirm
            placement="topRight"
            title={`Cancelar o convite enviado para ${record.email}?`}
            onConfirm={() => this.cancelInvitation(idEmpresa, record.email)}
            okText="Sim"
            cancelText="Não"
          >
            <Icon className="table-actions" type="close-circle" title="Cancelar convite" />
          </Popconfirm>
        ),
      },
    ];

    const tituloSecaoStyle = {
      display: 'block',
      fontWeight: 'bold',
      fontSize: 18,
      textAlign: 'left',
      background: '#fafafa',
      border: '1px solid #d9d9d9',
      borderRadius: 6,
      padding: '8px 16px',
      marginBottom: 24,
    };

    // "Convites pendentes" ganha um destaque proprio (amarelo bem clarinho)
    // pra diferenciar visualmente dos outros dois titulos - pedido do usuario
    // (2026-08-12).
    const tituloSecaoPendentesStyle = {
      ...tituloSecaoStyle,
      background: '#fffbe6',
    };

    // Largura das tabelas de usuarios - menor que a pagina inteira e
    // centralizada (2026-08-12, pedido do usuario), em vez de ocupar 100% da
    // largura disponivel.
    const larguraTabelaUsuarios = 860;
    const containerTabelaStyle = {
      maxWidth: larguraTabelaUsuarios,
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: 24,
    };

    // Cabecalho de cada grupo (nome da empresa + botao "Convidar usuário") em
    // flex pra empurrar o botao pra direita, alinhado com a coluna de Ações da
    // tabela logo abaixo (que tambem passou a ser align:'right') - pedido do
    // usuario (2026-08-12): botao alinhado com a lixeira, nao solto ao lado do
    // nome da empresa.
    const cabecalhoGrupoStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    };

    const filialText = <span>Criar Unidade</span>;
    const editText = <span>Editar</span>;

    return (
      <Layout>
        <Sidebar
          dataSidebar={homeClient}
          routes={routesClient}
          current="dashboard"
        />
        <Layout>
          <Header dataUser={this.state.dataUser} />
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              background: '#fff',
            }}
          >
            <Spin spinning={this.state.loading} size="large">
              <Row className="nopadding-col">
                <Col md={{ span: 10 }} xs={{ span: 24 }}>
                  <Breadcrumb pages={[{ title: 'Opções' }]} />
                </Col>
                <Col md={{ span: 6 }} xs={{ span: 24 }}>
                  <div className="new-item">
                    {Array.isArray(this.props.dataFilial) &&
                    this.props.dataFilial.length ? (
                      <Button
                        className="btn-add"
                        icon="tag"
                        onClick={() =>
                          this.abrirModalUtilizarCupom(this.props.dataFilial[0])
                        }
                      >
                        Utilizar Cupom
                      </Button>
                    ) : (
                      <Tooltip
                        placement="bottomLeft"
                        title="Para utilizar os cupons, selecione uma filial primeiro."
                      >
                        <Button disabled className="btn-add" icon="tag">
                          Utilizar Cupom
                        </Button>
                      </Tooltip>
                    )}
                  </div>
                </Col>
                <Col md={{ span: 8 }} xs={{ span: 24 }}>
                  <div className="new-item">
                    <Button
                      style={{ backgroundColor: '#00a1ed', color: '#FFF' }}
                      className="btn-add"
                      icon="plus"
                      onClick={() => this.props.history.push('/plansChoice')}
                    >
                      Criar novo grupo
                    </Button>
                  </div>
                </Col>
                <Col md={{ span: 8 }} xs={{ span: 24 }}>
                  <div className="new-item" style={{ display: 'none' }}>
                    <ModalCreateFilial
                      active
                      titleButton="Cadastrar unidade"
                      dataCompany={this.state.itemCompany}
                      onCreateFilial={async payload =>
                        this.onCreateFilial(payload)
                      }
                    />
                    <ModalInvitation
                      active
                      visible={this.state.visibleTeste}
                      dataCompanyFilial={this.state.itemFilial}
                      titleButton="Enviar convite"
                      createInvitation={payload =>
                        this.createInvitation(payload)
                      }
                    />
                    <ModalUpdateCompany
                      visible={this.state.visible}
                      titleButton="Editar grupo"
                      onClose={() => this.setState({ visible: false })}
                      segments={this.state.segment}
                      dataId={this.state.updateCompanyId}
                      updateCompany={data => this.updateCompany(data)}
                    />
                    <ModalUpdateFilial
                      visible={this.state.visibleUpdateFilial}
                      titleButton="Editar unidade"
                      dataId={this.state.updateFilialId}
                      onClose={() =>
                        this.setState({ visibleUpdateFilial: false })
                      }
                      updateCompany={data => this.updateFilial(data)}
                    />
                    <ModalBeneficio
                      visible={this.state.modalBeneficio.visible}
                      onCancel={this.fecharModalBeneficio()}
                      onSave={this.salvarBeneficio()}
                      fields={this.state.modalBeneficio.data}
                    />
                    <ModalUtilizarCupom
                      visible={this.state.modalUtilizarCupom.visible}
                      cupomSelecionado={
                        this.state.modalUtilizarCupom.cupomSelecionado
                      }
                      onCancel={this.fecharModalUtilizarCupom()}
                      onPesquisar={this.pesquisarCupom()}
                      onUtilizar={this.utilizarCupom()}
                      data={this.state.modalUtilizarCupom.data}
                    />
                    <ModalLogomarca
                      visible={this.state.modalLogomarca.visible}
                      empresaId={this.state.modalLogomarca.empresaId}
                      nomeEmpresa={this.state.modalLogomarca.nomeEmpresa}
                      nomeFilial={this.state.modalLogomarca.nomeFilial}
                      filialId={this.state.modalLogomarca.filialId}
                      onClose={() => {
                        this.setState({
                          modalLogomarca: {
                            visible: false,
                          },
                        });
                      }}
                    />
                    <ModalTemplateEmail
                      visible={this.state.modalTemplateEmail.visible}
                      empresaId={this.state.modalTemplateEmail.empresaId}
                      nomeEmpresa={this.state.modalTemplateEmail.nomeEmpresa}
                      onClose={() => {
                        this.setState({
                          modalTemplateEmail: {
                            visible: false,
                          },
                        });
                      }}
                    />
                    <ModalConvidarUsuario
                      visible={this.state.modalConvidarUsuario.visible}
                      empresa={this.state.modalConvidarUsuario.empresa}
                      unidades={
                        this.state.modalConvidarUsuario.empresa
                          ? dataFilial.filter(
                              f =>
                                f.idEmpresa ===
                                  this.state.modalConvidarUsuario.empresa.id &&
                                f.id !== 999999
                            )
                          : []
                      }
                      onClose={() =>
                        this.setState({
                          modalConvidarUsuario: { visible: false, empresa: null },
                        })
                      }
                      createInvitation={payload => this.createInvitation(payload)}
                    />
                    <ModalAdicionarUnidade
                      visible={this.state.modalAdicionarUnidade.visible}
                      registro={this.state.modalAdicionarUnidade.registro}
                      unidadesDisponiveis={
                        this.state.modalAdicionarUnidade.registro
                          ? (() => {
                              const registro = this.state.modalAdicionarUnidade.registro;
                              // IDs de filial que essa pessoa ja tem NESSA empresa -
                              // comparado por idFilial (nao nomeFilial, que nao e
                              // confiavel pra comparacao - duas unidades podem ter
                              // o mesmo nome).
                              const idsQueJaTem = (companyListUser || [])
                                .filter(
                                  u =>
                                    u.idVinculoFilial &&
                                    u.email === registro.email &&
                                    u.idEmpresa === registro.idEmpresa
                                )
                                .map(u => u.idFilial);
                              return dataFilial.filter(
                                f =>
                                  f.idEmpresa === registro.idEmpresa &&
                                  f.id !== 999999 &&
                                  !idsQueJaTem.includes(f.id)
                              );
                            })()
                          : []
                      }
                      onClose={() =>
                        this.setState({
                          modalAdicionarUnidade: { visible: false, registro: null },
                        })
                      }
                      adicionarUnidades={payload => this.adicionarUnidades(payload)}
                    />
                  </div>
                </Col>
              </Row>
              <Tabs type="card">
                <TabPane tab="Grupo / Unidade" key="1">
                  <Collapse accordion>
                    {this.props.dataUserCompany.map(item => {
                      return (
                        <Panel
                          header={`${item.nome}`}
                          key={item.id}
                          extra={
                            <Row
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              {/* Criar filial, editar empresa e logo da empresa sao
                                  acoes de nivel empresa - escondidas pra usuario
                                  restrito a uma unidade (2026-08-09). A autorizacao
                                  de verdade continua no backend; isso e so pra nao
                                  deixar a pessoa clicar em algo que vai dar erro. */}
                              {this.podeAdministrarEmpresa(item.id) && (
                                <Tooltip placement="topLeft" title={filialText}>
                                  <Icon
                                    style={{ marginRight: 15, fontSize: 18 }}
                                    type="plus-square"
                                    onClick={e => {
                                      e.stopPropagation();
                                      this.openModal(item);
                                    }}
                                  />
                                </Tooltip>
                              )}
                              {this.podeAdministrarEmpresa(item.id) && (
                                <Tooltip placement="topLeft" title={editText}>
                                  <Icon
                                    style={{ marginRight: 15, fontSize: 18 }}
                                    type="edit"
                                    onClick={event => {
                                      this.setState({
                                        itemFilial: item,
                                        updateCompanyId: item.id,
                                        visible: true,
                                        visibleTeste: false,
                                        visibleFilial: false,
                                        visibleUpdateFilial: false,
                                      });
                                      event.stopPropagation();
                                    }}
                                  />
                                </Tooltip>
                              )}
                              {this.podeAdministrarEmpresa(item.id) && (
                                <Tooltip
                                  placement="topLeft"
                                  title="Cadastrar logomarca grupo"
                                >
                                  <Icon
                                    style={{ marginRight: 15, fontSize: 18 }}
                                    type="file-image"
                                    onClick={event => {
                                      event.stopPropagation();
                                      this.abrirModalLogomarca(
                                        item.id,
                                        0,
                                        item.nome,
                                        ''
                                      );
                                    }}
                                  />
                                </Tooltip>
                              )}
                              {/* <Tooltip placement="topLeft" title={invitText}>
                                <Icon
                                  style={{ fontSize: 18 }}
                                  type="usergroup-add"
                                  onClick={e => {
                                    this.setState({
                                      itemFilial: item,
                                      visible: false,
                                      visibleTeste: true,
                                      visibleFilial: false,
                                      visibleUpdateFilial: false,
                                    });
                                    e.stopPropagation();
                                  }}
                                />
                              </Tooltip> */}
                            </Row>
                          }
                        >
                          <Row>
                            <Col
                              style={{ padding: '5px' }}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 12 }}
                              lg={{ span: 12 }}
                            >
                              <Collapse
                                defaultActiveKey="1"
                                onChange={this.callback}
                              >
                                {dataFilial &&
                                  dataFilial
                                    .filter(_item => {
                                      return (
                                        _item.idEmpresa === item.id &&
                                        _item.id != 999999
                                      );
                                    })
                                    .map(_item => {
                                      return (
                                        <Panel
                                          header={`${_item.nome}`}
                                          key={_item.id}
                                          extra={
                                            <Row
                                              style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <Col
                                                xs={{ span: 6 }}
                                                sm={{ span: 24 }}
                                                md={{ span: 24 }}
                                                lg={{ span: 10 }}
                                                style={{
                                                  display: 'flex',
                                                }}
                                              >
                                                <Tooltip
                                                  placement="topLeft"
                                                  title={editText}
                                                >
                                                  <Icon
                                                    style={{ fontSize: 14 }}
                                                    type="edit"
                                                    onClick={event => {
                                                      this.setState({
                                                        itemFilial: _item,
                                                        updateFilialId:
                                                          _item.id,
                                                        visible: false,
                                                        visibleTeste: false,
                                                        visibleFilial: false,
                                                        visibleUpdateFilial: true,
                                                      });
                                                      event.stopPropagation();
                                                    }}
                                                  />
                                                </Tooltip>
                                                <Tooltip
                                                  placement="topLeft"
                                                  title="Cadastrar logomarca unidade"
                                                >
                                                  <Icon
                                                    style={{
                                                      marginLeft: 15,
                                                      fontSize: 14,
                                                    }}
                                                    type="file-image"
                                                    onClick={event => {
                                                      event.stopPropagation();
                                                      this.abrirModalLogomarca(
                                                        item.id,
                                                        _item.id,
                                                        item.nome,
                                                        _item.nome
                                                      );
                                                    }}
                                                  />
                                                </Tooltip>
                                              </Col>
                                            </Row>
                                          }
                                        >
                                          {!this.state.showLink ? (
                                            <div
                                              style={{
                                                display: 'flex',
                                                gap: '8px',
                                                padding: '16px',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <div>
                                                <img
                                                  src={this.generateQRCodeUrl(
                                                    `${this.service.endPointQuestionario}/${item.id}/${_item.id}`
                                                  )}
                                                  alt=""
                                                  style={{
                                                    width: 80,
                                                  }}
                                                />
                                              </div>

                                              <div>
                                                <div>
                                                  <label>
                                                    Avaliação padrão:{' '}
                                                  </label>
                                                  <a
                                                    href={`${this.service.endPointQuestionario}/${item.id}/${_item.id}`}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                  >
                                                    {
                                                      this.service
                                                        .endPointQuestionario
                                                    }
                                                    /{item.id}/{_item.id}
                                                  </a>
                                                </div>

                                                <div>
                                                  <label>
                                                    Avaliação com reinício
                                                    automático:{' '}
                                                  </label>
                                                  <a
                                                    href={`${this.service.endPointQuestionario}/${item.id}/${_item.id}?quiosque`}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                  >
                                                    {
                                                      this.service
                                                        .endPointQuestionario
                                                    }
                                                    /{item.id}/{_item.id}
                                                    ?quiosque
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <Row>
                                            <RedeSocial filial={_item.id} />
                                          </Row>
                                        </Panel>
                                      );
                                    })}
                              </Collapse>
                            </Col>
                            <Col
                              style={{ padding: '5px' }}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 12 }}
                              lg={{ span: 12 }}
                            >
                              {item.beneficio ? (
                                <Card>
                                  <h1>
                                    {/* Configurar cupom e nivel empresa - escondido
                                        pro restrito a uma unidade (2026-08-09). */}
                                    {this.podeAdministrarEmpresa(item.id) && (
                                      <Tooltip
                                        placement="topLeft"
                                        title="Alterar dados do prêmio"
                                      >
                                        <Icon
                                          style={{
                                            marginRight: 15,
                                            fontSize: 18,
                                          }}
                                          type="edit"
                                          onClick={() =>
                                            this.abrirModalBeneficio(
                                              item.beneficio
                                            )
                                          }
                                        />
                                      </Tooltip>
                                    )}
                                    {/* Editar e-mail do cupom e nivel empresa - faltou
                                        esconder pro restrito quando a checagem foi
                                        adicionada nos outros icones (2026-08-09);
                                        achado pelo usuario em 2026-08-11. */}
                                    {this.podeAdministrarEmpresa(item.id) && (
                                      <Tooltip
                                        placement="topLeft"
                                        title="Editar e-mail do cupom"
                                      >
                                        <Icon
                                          style={{
                                            marginRight: 15,
                                            fontSize: 18,
                                          }}
                                          type="mail"
                                          onClick={event => {
                                            event.stopPropagation();
                                            this.abrirModalTemplate(
                                              item.id,
                                              item.nome
                                            );
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                    Prêmio: {item.beneficio.nome}
                                  </h1>
                                  <Row>
                                    <Col span={16}>Prêmio ativo?</Col>
                                    <Col span={8}>
                                      <strong>
                                        {' '}
                                        {item.beneficio.ativo ? 'SIM' : 'NÃO'}
                                      </strong>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col span={16}>Vigência inicial:</Col>
                                    <Col span={8}>
                                      <strong>
                                        {' '}
                                        {`${moment(
                                          item.beneficio.dataInicial
                                        ).format('DD/MM/YYYY')}`}
                                      </strong>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col span={16}>Vigência final:</Col>
                                    <Col span={8}>
                                      <strong>
                                        {' '}
                                        {`${moment(
                                          item.beneficio.dataFinal
                                        ).format('DD/MM/YYYY')}`}
                                      </strong>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col span={16}>Limite de cupons:</Col>
                                    <Col span={8}>
                                      <strong>
                                        {' '}
                                        {`${
                                          item.beneficio.maximoCupons
                                            ? item.beneficio.maximoCupons
                                            : 'ILIMITADO'
                                        }`}
                                      </strong>
                                      <Tooltip
                                        placement="topLeft"
                                        title="Número máximo de cupons disponíveis no prêmio."
                                      >
                                        <Icon
                                          style={{
                                            marginLeft: 5,
                                            fontSize: 14,
                                          }}
                                          type="question-circle"
                                        />
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col span={16}>Validade do cupom:</Col>
                                    <Col span={8}>
                                      <strong>
                                        {' '}
                                        {`${item.beneficio.validadeCupomDias}`}{' '}
                                        {item.beneficio.validadeCupomDias > 1
                                          ? 'dias'
                                          : 'dia'}
                                      </strong>
                                      <Tooltip
                                        placement="topLeft"
                                        title="Período que o cupom é válido a partir de sua geração."
                                      >
                                        <Icon
                                          style={{
                                            marginLeft: 5,
                                            fontSize: 14,
                                          }}
                                          type="question-circle"
                                        />
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col span={16}>Limite para confirmar:</Col>
                                    <Col span={8}>
                                      <strong>
                                        {`${item.beneficio.tempoMaximoConfirmacaoHoras}`}{' '}
                                        {item.beneficio
                                          .tempoMaximoConfirmacaoHoras > 1
                                          ? 'hs'
                                          : 'h'}
                                      </strong>
                                      <Tooltip
                                        placement="topLeft"
                                        title="Tempo máximo para aguardar a validação do cupom. Após este período sem confirmação o cupom se torna inválido."
                                      >
                                        <Icon
                                          style={{
                                            marginLeft: 5,
                                            fontSize: 14,
                                          }}
                                          type="question-circle"
                                        />
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col span={16}>
                                      Aguardar antes de utilizar:
                                    </Col>
                                    <Col span={8}>
                                      <strong>
                                        {' '}
                                        {`${item.beneficio.tempoAguardarUtilizacaoHoras}`}{' '}
                                        {item.beneficio
                                          .tempoAguardarUtilizacaoHoras > 1
                                          ? 'hs'
                                          : 'h'}
                                      </strong>
                                      <Tooltip
                                        placement="topLeft"
                                        title="Tempo que o beneficiado deverá aguardar antes de utilizar seu cupom."
                                      >
                                        <Icon
                                          style={{
                                            marginLeft: 5,
                                            fontSize: 14,
                                          }}
                                          type="question-circle"
                                        />
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                  {this.state.showRankCupom ? (
                                    <>
                                      <Row>
                                        <Col span={24}>
                                          <hr />
                                          <h1>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="stock"
                                            />
                                            Estatísticas
                                          </h1>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          Total de cupons já emitidos:
                                        </Col>
                                        <Col span={8}>
                                          <strong>
                                            {
                                              (
                                                item.beneficio.estatisticas ||
                                                {}
                                              ).totalCupons
                                            }
                                          </strong>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          <span>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="caret-right"
                                            />
                                            Total de cupons validados:
                                          </span>
                                        </Col>
                                        <Col span={8}>
                                          {
                                            (item.beneficio.estatisticas || {})
                                              .totalCuponsValidados
                                          }
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          <span>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="right"
                                            />
                                            Validados e já utilizados:
                                          </span>
                                        </Col>
                                        <Col span={8}>
                                          {
                                            (item.beneficio.estatisticas || {})
                                              .totalCuponsValidadosUtilizados
                                          }
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          <span>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="right"
                                            />
                                            Validados e aguardando utilização:
                                          </span>
                                        </Col>
                                        <Col span={8}>
                                          {
                                            (item.beneficio.estatisticas || {})
                                              .totalCuponsValidadosAguardandoUtilizacao
                                          }
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          <span>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="right"
                                            />
                                            Validados mas já expirados:
                                          </span>
                                        </Col>
                                        <Col span={8}>
                                          {
                                            (item.beneficio.estatisticas || {})
                                              .totalCuponsValidadosExpirados
                                          }
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          <span>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="caret-right"
                                            />
                                            Total de cupons não validados:
                                          </span>
                                        </Col>
                                        <Col span={8}>
                                          {
                                            (item.beneficio.estatisticas || {})
                                              .totalCuponsNaoValidados
                                          }
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          <span>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="right"
                                            />
                                            Não validados e ainda no prazo:
                                          </span>
                                        </Col>
                                        <Col span={8}>
                                          {
                                            (item.beneficio.estatisticas || {})
                                              .totalCuponsNaoValidadosAguardando
                                          }
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          <span>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="right"
                                            />
                                            Não validados e já expirados:
                                          </span>
                                        </Col>
                                        <Col span={8}>
                                          {
                                            (item.beneficio.estatisticas || {})
                                              .totalCuponsNaoValidadosExpirados
                                          }
                                        </Col>
                                      </Row>
                                    </>
                                  ) : (
                                    <>
                                      <Row>
                                        <Col span={24}>
                                          <hr />
                                          <h1>
                                            <Icon
                                              style={{
                                                marginRight: 15,
                                                fontSize: 18,
                                              }}
                                              type="stock"
                                            />
                                            Estatísticas
                                          </h1>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col span={16}>
                                          Total de cupons já enviados:
                                        </Col>
                                        <Col span={8}>
                                          <strong>
                                            {
                                              (
                                                item.beneficio.estatisticas ||
                                                {}
                                              ).totalCupons
                                            }
                                          </strong>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </Card>
                              ) : (
                                <Card>
                                  <h1>
                                    Você ainda não tem nenhum prêmio
                                    configurado.
                                  </h1>
                                  {this.podeAdministrarEmpresa(item.id) && (
                                    <a
                                      href="#"
                                      onClick={() =>
                                        this.abrirModalBeneficio({
                                          idBeneficio: 0,
                                          idEmpresa: item.id,
                                        })
                                      }
                                    >
                                      Clique aqui e cadastre seu primeiro prêmio.
                                    </a>
                                  )}
                                </Card>
                              )}
                            </Col>
                          </Row>
                        </Panel>
                      );
                    })}
                  </Collapse>
                </TabPane>
                <TabPane tab="Usuários" key="2">
                  <h3 style={tituloSecaoStyle}>Acesso total</h3>
                  {gruposAcessoTotal.length > 0 ? (
                    gruposAcessoTotal.map(grupo => (
                      <div
                        key={`empresa-${grupo.idEmpresa}`}
                        style={containerTabelaStyle}
                      >
                        <div style={cabecalhoGrupoStyle}>
                          <h4 style={{ margin: 0 }}>{grupo.nomeEmpresa}</h4>
                          {botaoConvidar(grupo.idEmpresa, grupo.nomeEmpresa)}
                        </div>
                        <Table
                          className="table"
                          style={{ width: '100%' }}
                          columns={columnsAcessoTotal}
                          dataSource={grupo.usuarios}
                          rowKey={item => `empresa-${item.idVinculoEmpresa}`}
                          size="middle"
                          pagination={false}
                          showHeader={false}
                        />
                      </div>
                    ))
                  ) : (
                    <p>Nenhum usuário com acesso total encontrado.</p>
                  )}
                  <Divider />
                  <h3 style={tituloSecaoStyle}>Acesso restrito</h3>
                  {gruposAcessoRestrito.length > 0 ? (
                    gruposAcessoRestrito.map(grupo => (
                      <div
                        key={`empresa-${grupo.idEmpresa}`}
                        style={containerTabelaStyle}
                      >
                        <div style={cabecalhoGrupoStyle}>
                          <h4 style={{ margin: 0 }}>{grupo.nomeEmpresa}</h4>
                          {idsComBotaoNoRestrito.has(grupo.idEmpresa) &&
                            botaoConvidar(grupo.idEmpresa, grupo.nomeEmpresa)}
                        </div>
                        <Table
                          className="table"
                          style={{ width: '100%' }}
                          columns={columnsAcessoRestrito(grupo.idEmpresa)}
                          dataSource={grupo.usuarios}
                          rowKey={item => `filial-${item.idVinculoFilial}`}
                          size="middle"
                          pagination={false}
                          showHeader={false}
                        />
                      </div>
                    ))
                  ) : (
                    <p>Nenhum usuário com acesso restrito encontrado.</p>
                  )}
                  {gruposPendentes.length > 0 && (
                    <>
                      <Divider />
                      <h3 style={tituloSecaoPendentesStyle}>Convites pendentes</h3>
                      {gruposPendentes.map(grupo => (
                        <div
                          key={`empresa-${grupo.idEmpresa}`}
                          style={containerTabelaStyle}
                        >
                          <div style={cabecalhoGrupoStyle}>
                            <h4 style={{ margin: 0 }}>{grupo.nomeEmpresa}</h4>
                            {!idsComBotaoNoTotal.has(grupo.idEmpresa) &&
                              !idsComBotaoNoRestrito.has(grupo.idEmpresa) &&
                              botaoConvidar(grupo.idEmpresa, grupo.nomeEmpresa)}
                          </div>
                          <Table
                            className="table"
                            style={{ width: '100%' }}
                            columns={columnsPendentes}
                            dataSource={grupo.usuarios}
                            rowKey={item => `pendente-${item.idEmpresa}-${item.email}`}
                            size="middle"
                            pagination={false}
                            showHeader={false}
                          />
                        </div>
                      ))}
                    </>
                  )}
                </TabPane>
                <TabPane tab="Alertas" key="3">
                  <Alerts
                    alertStatus={this.state.alertStatus}
                    setAlertStatus={this.setAlertStatus}
                  />
                </TabPane>
                <TabPane tab="Editar avaliações" key="4">
                  <QuestionsClient
                    data={this.state.dataQuestions}
                    dataPerguntasFilial={this.state.dataQuestionsEmpresa}
                    company={this.state.data}
                    saveQuestions={this.saveQuestions}
                    podeAdministrarEmpresa={this.podeAdministrarEmpresa}
                  />
                </TabPane>
              </Tabs>
            </Spin>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getDataUserCompany, getModalTrue, getIdFilial },
    dispatch
  );

const mapStateToProps = store => ({
  userData: store.userData.data,
  dataUserCompany: store.userData.dataUserCompany,
  clientFilial: store.userData.clientFilial,
  filialId: store.userData.filialId,
  dataFilial: store.userData.dataFilial,
  companySelected: store.userData.companySelected,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SettingsBlue));
